// extracted by mini-css-extract-plugin
module.exports = {"botonsIdiomesWrapper":"botonsidiomes_botonsIdiomesWrapper__SHsb_","botoIdiomes":"botonsidiomes_botoIdiomes__34lfY","botoActive":"botonsidiomes_botoActive__OaBR1"};